import _ from 'lodash';
import { logger } from '@/utils/log';

let messageInstanceList = [];
const maxNumber = 1;

export default {
  name: 'messageMixin',
  methods: {
    showMessage({ message, duration = 0, type = 'error', showClose = true, onClose, dangerouslyUseHTMLString = true }) {
      const instance = this.$message({
        type,
        message,
        duration,
        showClose,
        onClose,
        dangerouslyUseHTMLString,
      });

      messageInstanceList?.push(instance);

      const visibleMessageInstanceList = _.filter(messageInstanceList, (p) => p?.visible);
      const visibleInstanceNumber = visibleMessageInstanceList?.length || 0;

      if (visibleInstanceNumber > maxNumber) {
        _.forEach(visibleMessageInstanceList, (p, index) => {
          if (index < (visibleInstanceNumber - maxNumber)) {
            messageInstanceList = _.filter(messageInstanceList, (x) => x !== p);
            p?.close();
          }
        });
      }
      return instance;
    },
    hideMessages() {
      messageInstanceList?.forEach(instance => {
        try {
          typeof instance?.close === 'function' && instance.close();
        } catch (e) {
          logger.error('Can not close message instance', e);
        }
      });
    }
  },
};
